"use client";

import { useSyncExternalStore } from "react";
import { APP_VERSION, readDisplayedAppVersion } from "../app-version";

const NATIVE_READY_EVENT = "award-party:native-ready";

function subscribeToNativeShell(callback: () => void) {
  window.addEventListener(NATIVE_READY_EVENT, callback);
  return () => window.removeEventListener(NATIVE_READY_EVENT, callback);
}

function readProductVersion(): string {
  return APP_VERSION;
}

export function useDisplayedAppVersion(): string {
  return useSyncExternalStore(
    subscribeToNativeShell,
    readDisplayedAppVersion,
    readProductVersion,
  );
}
